// extracted by mini-css-extract-plugin
module.exports = {"root":"PackagePrice_root__19uBD","amount":"PackagePrice_amount__2A467","unit":"PackagePrice_unit__1yE9L","badge":"PackagePrice_badge__1D6IK"};